import React from "react";
import { Box } from "@mui/material";
import LayoutAuth from "@/theme/layout-auth";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "@/hooks/useTranslation";
import { useLoginForm } from "@/hooks/auth/useLoginForm";
import EmailStep from "@/components/auth/login/EmailStep";
import VerificationStep from "@/components/auth/login/VerificationStep";
import ErrorMessage from "@/components/auth/common/ErrorMessage";

const LoginPage = () => {
    const { t } = useTranslation();
    const { isAuthenticated } = useAuth();
    
    const {
        email,
        code,
        step,
        isEmailValid,
        isLoading,
        error,
        handleEmailChange,
        handleCodeChange,
        handleRequestCode,
        handleVerifyCode,
        handleResendCode,
        handleTryAnotherEmail,
        handleKeyPress
    } = useLoginForm(isAuthenticated);

    return (
        <LayoutAuth>
            <Box sx={{ width: "100%", maxWidth: 400, margin: "auto" }}>
                <h1>{t('auth.login.title')}</h1>
                
                {/* Step 1: Email Input */}
                {step === 1 && (
                    <EmailStep 
                        email={email}
                        onChange={handleEmailChange}
                        onSubmit={handleRequestCode}
                        isEmailValid={isEmailValid}
                        isLoading={isLoading}
                        onKeyPress={handleKeyPress}
                    />
                )}
                
                {/* Step 2: Code Verification */}
                {step === 2 && (
                    <VerificationStep
                        email={email}
                        code={code}
                        onChange={handleCodeChange}
                        onSubmit={handleVerifyCode}
                        onResendCode={handleResendCode}
                        onTryAnotherEmail={handleTryAnotherEmail}
                        isLoading={isLoading}
                        onKeyPress={handleKeyPress}
                    />
                )}
                
                {/* Error Display */}
                {error && <ErrorMessage message={error} />}
            </Box>
        </LayoutAuth>
    );
};

export default LoginPage;